import React, { useState, useEffect } from "react";
import { Table, Input, DatePicker, Icon } from "antd";
import { ColumnProps } from "antd/es/table";
import {
    getChannelViewingStatistics,
    ViewType,
    DataType,
    exportViewCount
} from "service/liveRecord";
import titleIcon from "../../img/titleIcon.png";
import moment from "moment";
import useRequest from "utils/useRequest";
// import  { SorterResult } from 'antd/es/table/interface';
import style from "./index.module.scss";
interface WatchType {
    channelId: string;
}
interface SortType {
    key: string;
    lastActiveTime: string; //最后进入时间
    orderNum: number; //序号
    duration: number; //直播时长
    firstActiveTime: string; //首次进入时间
    currentDay: string; //日期
    liveAllTime: number; //观看时长
    vodAllTime: number; //观看回放时长
    vodNum: number; //观看回放次数
}
export default function Watch({ channelId }: WatchType) {
    const defaultFilter = {
        userName: "",
        firstActiveTime: "",
        lastActiveTime: "",
        channelId: channelId
    };
    const defaultPage = {
        pageNo: 1,
        pageSize: 10
    };
    const [userName, setUserName] = useState("");
    const [date, setDate] = useState({
        firstActiveTime: "",
        lastActiveTime: ""
    });
    const [sortBy, setSort] = useState("");
    const [scrollText, setScroll] = useState("加载更多....");
    const [pagination, setPage] = useState(defaultPage);
    const [filter, setFilter] = useState<DataType>(defaultFilter);
    const [data, { loading }, refreshData] = useRequest<ViewType[]>(
        () => getChannelViewingStatistics({ ...filter, myOrderBy: sortBy }),
        {},
        [filter, sortBy]
    );
    const [newData, setData] = useState<ViewType[]>([]);
    const rowClassName = () => {
        return "customRow";
    };
    const dateChange = (e: any) => {
        if (e.length > 0) {
            setDate({
                firstActiveTime: moment(e?.[0]).valueOf().toString(),
                lastActiveTime: moment(e?.[1]).valueOf().toString()
            });
        } else {
            setDate({
                firstActiveTime: "",
                lastActiveTime: ""
            });
        }
    };
    const searchData = (e: any) => {
        e.preventDefault();
        setPage(defaultPage);
        setFilter({ ...filter, userName, ...date });
    };
    useEffect(() => {
        if (data) {
            setScroll("加载更多...");
            setData([]);
            let page = pagination.pageNo;
            setData([...data?.slice(page - 1, pagination.pageSize)]);
            setPage({ ...pagination, pageNo: page + 1 });
        }
    }, [data]);
    function debounce(fn: any, wait: number) {
        let timer: any = null;
        return function () {
            if (timer !== null) {
                clearTimeout(timer);
            }
            timer = setTimeout(fn, wait);
        };
    }
    const handleScroll1 = debounce(() => {
        if (data) {
            let page = pagination.pageNo;
            if (
                Math.ceil(window.scrollY) +
                    Number(document.body.clientHeight) >=
                    Number(document.body.scrollHeight) - 100 &&
                Math.ceil(data?.length / pagination.pageSize) >= page
            ) {
                setScroll("加载更多....");
                let dataArr = [...data];
                setData([
                    ...dataArr,
                    ...dataArr?.slice(
                        (page - 1) * pagination.pageSize,
                        pagination.pageSize
                    )
                ]);
                setPage({ ...pagination, pageNo: pagination.pageNo + 1 });
            } else {
                setScroll("没有更多了");
            }
        }
    }, 500);
    useEffect(() => {
        window.addEventListener("scroll", handleScroll1);
        return () => {
            window.removeEventListener("scroll", handleScroll1);
        };
    }, [pagination]);
    const columns: ColumnProps<ViewType>[] = [
        {
            title: "序号",
            dataIndex: "orderNum",
            key: "orderNum",
            align: "center",
            ellipsis: true,
            sorter: true,
            width: "7%"
        },
        {
            title: "学生信息",
            key: "userName",
            ellipsis: true,
            width: "10%",
            render: (record: any) => {
                return (
                    <div className={style.watchTableName}>
                        <div className={style.name}>{record.userName}</div>
                        <div className={style.no}>{record.userId}</div>
                    </div>
                );
            }
        },
        {
            title: "日期",
            dataIndex: "currentDay",
            key: "currentDay",
            align: "center",
            ellipsis: true,
            sorter: true,
            width: "15%"
        },
        {
            title: "直播时长(分钟)",
            dataIndex: "duration",
            key: "duration",
            align: "center",
            ellipsis: true,
            sorter: true
        },
        {
            title: "观看时长(分钟)",
            dataIndex: "liveAllTime",
            key: "liveAllTime",
            align: "center",
            ellipsis: true,
            sorter: true
        },

        {
            title: "首次进入时间",
            dataIndex: "firstActiveTime",
            key: "firstActiveTime",
            align: "center",
            ellipsis: true,
            sorter: true
        },
        {
            title: "最后进入时间",
            dataIndex: "lastActiveTime",
            key: "lastActiveTime",
            align: "center",
            ellipsis: true,
            sorter: true
        },
        {
            title: "回放时长(分钟)",
            dataIndex: "vodAllTime",
            key: "vodAllTime",
            align: "center",
            ellipsis: true,
            sorter: true
        },
        {
            title: "回放次数",
            dataIndex: "vodNum",
            key: "vodNum",
            align: "center",
            ellipsis: true,
            sorter: true
        }
    ];
    const handleChange = (pagination: any, filters: any, sorter: any) => {
        setPage(defaultPage);
        if (sorter.order === "descend") {
            setSort(sorter.columnKey.concat(" ").concat("desc"));
        } else if (sorter.order === "ascend") {
            setSort(sorter.columnKey);
        } else {
            setSort("");
        }
    };
    return (
        <div>
            <div className={style.header}>
                <img className={style.titleIcon} src={titleIcon} alt="" />
                观看统计
                <form className={style.search} onSubmit={e => searchData(e)}>
                    <Input
                        className={style.searchInput}
                        onChange={e => setUserName(e.target.value.trim())}
                        placeholder="请输入学生信息"
                    />
                    <DatePicker.RangePicker
                        className={style.searchTime}
                        showTime={{ format: "HH:mm" }}
                        format="YYYY-MM-DD HH:mm"
                        placeholder={["开始时间", "结束时间"]}
                        onChange={dateChange}
                    />
                    <button className={style.btn}>
                        <Icon className={style.btnIcon} type="search" />
                        查询
                    </button>
                    <div
                        className={style.exportData}
                        onClick={() => exportViewCount(channelId)}>
                        <Icon className={style.btnIcon} type="cloud-download" />
                        导出数据
                    </div>
                </form>
            </div>
            <Table
                rowKey="id"
                pagination={false}
                loading={loading}
                columns={columns}
                dataSource={newData!}
                rowClassName={rowClassName}
                onChange={handleChange}
            />
            <p className={style.scrollText}>{scrollText}</p>
        </div>
    );
}
